import { type SupportChatStorage } from './types.ts';

const SESSION_STORAGE_KEY = 'dibsSupportChat';

const DEFAULT_SESSION_STORAGE: SupportChatStorage = {
    activeChat: null,
    touchpoint: null,
    isButtonVisible: 'no',
    isWindowVisible: 'no',
    hasUnreadMessage: 'no',
    showChatButtonOnLoad: 'no',
    preChatFields: {
        pageType: '',
        topic: '',
        itemId: undefined,
        orderId: undefined,
    },
    salesforceJwt: null,
};

export { DEFAULT_SESSION_STORAGE, SESSION_STORAGE_KEY };
